import { render } from "./OverlayInstallation.vue?vue&type=template&id=89c24c72&scoped=true"
import script from "./OverlayInstallation.vue?vue&type=script&lang=js"
export * from "./OverlayInstallation.vue?vue&type=script&lang=js"

import "./OverlayInstallation.vue?vue&type=style&index=0&id=89c24c72&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c24c72"]])

export default __exports__